import React, { useState, useEffect } from "react";
import { Table, Button, Input, Form, message, Pagination } from "antd";
import { subItemHooks } from "../hooks";
const TagLayout = () => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 태그 목록 가져오기
  const fetchTags = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await subItemHooks.tagList({ page: currentPage });
      const { data, cnt } = response.data; // 태그 데이터와 전체 태그 수
      console.log(data, cnt);
      setTags(data);
      setTotal(cnt);
    } catch (error) {
      console.error("태그 데이터를 가져오는 중 오류가 발생했습니다.", error);
    } finally {
      setLoading(false);
    }
  };

  // 태그 생성
  const handleCreate = async (values) => {
    try {
      const res = await subItemHooks.tagCreate({ tags: values });
      if (res.IsError) {
        throw new Error("create tag error");
      }
      message.success("태그가 생성되었습니다.");
      fetchTags(page); // 현재 페이지 새로고침
    } catch (error) {
      console.error("태그 생성 중 오류가 발생했습니다.", error);
      message.error("태그 생성에 실패했습니다.");
    }
  };

  // 태그 삭제
  const handleDelete = async (id) => {
    try {
      const res = await subItemHooks.tagDelete({ id: id });
      if (res.IsError) {
        throw new Error("delete tag error");
      }
      message.success("태그가 삭제되었습니다.");
      fetchTags(page); // 현재 페이지 새로고침
    } catch (error) {
      console.error("태그 삭제 중 오류가 발생했습니다.", error);
      message.error("태그 삭제에 실패했습니다.");
    }
  };

  // 페이지 변경 처리
  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchTags(newPage); // 선택된 페이지 데이터 가져오기
  };

  useEffect(() => {
    fetchTags(page);
  }, [page]);

  const columns = [
    {
      title: "태그명",
      dataIndex: "tag_name",
    },
    {
      title: "태그 삭제",
      render: (record) => (
        <Button type="link" danger onClick={() => handleDelete(record.id)}>
          삭제
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Form
        layout="inline"
        onFinish={(values) => handleCreate(values)}
        style={{ marginBottom: "20px" }}
      >
        <Form.Item
          name="tag_name"
          rules={[{ required: true, message: "태그명을 입력해주세요." }]}
        >
          <Input
            placeholder="새 태그 입력 (예: 난임,임신,출산)"
            style={{ width: 400 }}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            태그 생성
          </Button>
        </Form.Item>
      </Form>
      <Table
        columns={columns}
        dataSource={tags}
        rowKey="id"
        loading={loading}
        pagination={false} // 페이지네이션은 별도로 처리
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10} // 한 페이지에 표시할 태그 수
        onChange={handlePageChange}
        style={{ marginTop: "20px", textAlign: "center" }}
      />
    </div>
  );
};

export default TagLayout;
